/* eslint-disable react/jsx-indent-props */
/* eslint-disable react/jsx-indent */
import React, { useRef } from 'react';
import { PropTypes } from 'prop-types';
import LocationMapError from './LocationMapError';
import { buildFullAddress } from '../utils/buildFullAddress';
import { useGoogleMaps } from '../hooks/useGoogleMaps';

const LocationMap = ({ address, city, state, postalCode, mapUrl }) => {
	const ref = useRef(null);
	const fullAddress = buildFullAddress({
		address,
		city,
		state,
		postalCode
	});

	const [loaded, error] = useGoogleMaps({
		address,
		city,
		state,
		postalCode,
		fullAddress,
		mapRef: ref
	});

	const handleMapClick = () => {
		window.open(mapUrl, '_blank');
	};

	// Show error fallback
	if (error) {
		return <LocationMapError mapUrl={mapUrl} />;
	}

	return (
		<div className="location-map d-flex flex-column pl-sm-5 pr-sm-3 border-radius-md">
			<div
				ref={ref}
				onClick={handleMapClick}
				className="location-map__map-container w-100 position-relative"
				role="button"
				tabIndex={0}
				onKeyPress={(e) => {
					if (e.key === 'Enter' || e.key === ' ') {
						handleMapClick();
					}
				}}
				aria-label={`Click to open ${fullAddress} in Google Maps`}
			/>
			{!loaded && (
				<div className="position-absolute location-map__loading-indicator p-2 border-radius-sm">
					Loading map...
				</div>
			)}
		</div>
	);
};

LocationMap.propTypes = {
	address: PropTypes.string.isRequired,
	city: PropTypes.string.isRequired,
	state: PropTypes.string.isRequired,
	postalCode: PropTypes.string.isRequired,
	mapUrl: PropTypes.string.isRequired
};

export default LocationMap;
